import {
    CREATE_ARCHITECTUREPAYSLIP,
    RETRIEVE_ARCHITECTUREPAYSLIP,
    RETRIEVESINGLE_ARCHITECTUREPAYSLIP,
    UPDATE_ARCHITECTUREPAYSLIP,
    DELETE_ARCHITECTUREPAYSLIP,
  } from "../actions/type";
  const initialState = [];
  function ARCPayslipReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_ARCHITECTUREPAYSLIP:
        return {data: state.data, payload};
      case RETRIEVE_ARCHITECTUREPAYSLIP:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_ARCHITECTUREPAYSLIP:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_ARCHITECTUREPAYSLIP:
        return {data: state.data, payload};
      case DELETE_ARCHITECTUREPAYSLIP:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {ARCPayslipReducer};